import { APPEND_FILTER, RESET_FILTER, RESET_LANG_FILTER } from "./actionTypes";

const INITIAL_STATE = {
	getRanges: false,
	budgetRange: [30000, 100000000],
	sizeRange: [50, 10000],
	budget: [1, 100000000],
	size: [1, 2000],
	unitType: [],
	finishingType: [],
	location: null,
	ResaleLocation: "",
	payment: null,
	categories_ids: [],
	activeTab: "1",
	compound: "",
	resale: "",
	delivery: "",
	downPayment: 0,
	bedrooms: [],
	bathrooms: [],
	floor: [],
	compound_type: "",
	paymentMethod: "",
	unitTypeOptions: [],
	finishingOptions: [],
	paymentOptions: [],
	CategortiesOptions: [],
	homeCompounds: [],
	homeResales: [],
	bestCompounds: [],
	paymentMethods: [],
	loading: false,
	unit: "",
	comparedIds: [],
	country: "",
	floorRange: [],
	bedroomsRange: [],
	bathroomsRange: [],
	per_page: 11,
	page: 1,
	from: "",
};

const filterReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case APPEND_FILTER:
			return { ...state, ...action.payload, loading: true };
		case RESET_FILTER:
			return {
				...state,
				unitType: [],
				finishingType: [],
				location: "",
				ResaleLocation: "",
				payment: null,
				categories_ids: [],
				activeTab: "1",
				compound: "",
				resale: "",
				delivery: "",
				downPayment: 0,
				payment_type: "",
				bedrooms: [],
				bathrooms: [],
				floor: [],
				compound_type: "",
				paymentMethod: "",
				paymentMethods: [],
				loading: false,
				unit: "",
				comparedIds: [],
				country: "",
				page: 1,
			};
		case RESET_LANG_FILTER:
			return {
				...state,
				unitType: [],
				finishingType: [],
				location: null,
				ResaleLocation: "",
				payment: null,
				categories_ids: [],
				compound: "",
				resale: "",
				bedrooms: [],
				bathrooms: [],
				floor: [],
				paymentMethods: [],
				unit: "",
				comparedIds: [],
			};
		default:
			return state;
	}
};

export default filterReducer;
